import { ADD_A_TAG_TO_APT } from './constants';
import { TagRecord } from './fetchAptConfig';
import fetchWithRefresh from './fetchWithRefresh';

export interface TagAppointmentResponse {
    success: boolean;
    error?: string;
}

export default async function linkTagWithApt(
    businessId: string,
    tagId: TagRecord['tag_id'],
    aid: string,
): Promise<TagAppointmentResponse> {
    const response = await fetchWithRefresh(ADD_A_TAG_TO_APT(businessId, aid), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tagId }),
    });

    const res = await response.json();
    return res;
}
